import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import FarmForm from "components/agro/farms/FarmForm";
import { updateFarm } from "graphql/mutations";
import { getFarm } from "graphql/queries";

const FarmUpdateForm = ({ farmId, onSuccess }) => {
  const navigate = useNavigate();
  const [farm, setFarm] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        location,
        description,
        companyID,
        sizeM2,
        averageAltitudeM,
        responsiblePersonId,
        photoEvidence,
        blueprints,
      } = valuesParam;

      await API.graphql({
        query: updateFarm.replaceAll("__typename", ""),
        variables: {
          input: {
            id: farmId,
            name,
            location,
            description,
            companyID,
            sizeM2:
              sizeM2 === undefined || sizeM2 === "" ? null : Number(sizeM2),
            averageAltitudeM:
              averageAltitudeM === undefined || averageAltitudeM === ""
                ? null
                : Number(averageAltitudeM),
            responsiblePersonId,
            photoEvidence,
            blueprints,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/agro/farms");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchFarm(id) {
    try {
      const farmData = await API.graphql(graphqlOperation(getFarm, { id }));
      const farmItem = farmData.data.getFarm;
      if (!farmItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/agro/farms");
        return;
      }
      setFarm({
        ...farmItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchFarm(farmId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [farmId]);

  if (!farm) return <Loader />;

  return (
    <div>
      <FarmForm onSubmit={onSubmit} type="update" initialValues={farm} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Finca",
    successUpdated: "Finca actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar la finca",
    },
  },
});

export default FarmUpdateForm;
